import { useEffect, useState } from "react";

const useScreenSize = ({ mobileWidth = 768, tabletWidth = 1024 } = {}) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);

  const handleResize = () => {
    setIsMobile(window.innerWidth < mobileWidth);
    setIsTablet(
      window.innerWidth >= mobileWidth && window.innerWidth < tabletWidth
    );
  };

  useEffect(() => {
    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return { isMobile, isTablet };
};

export default useScreenSize;
